export default {
  title: {
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontWeight: 300,
    fontSize: 25,
    marginTop: 0,
    marginBottom: 22,
  }
};